import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
} from '@mui/material';
import { useAudio } from '../context/AudioContext';

const Navbar = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const isAuthenticated = !!token; // Define isAuthenticated based on token presence
  const { handlePlayPause, isPlaying, setCurrentSong, setIsPlaying } = useAudio();

  const handleLogout = () => {
    // Stop music playback
    if (isPlaying) {
      handlePlayPause(); // This will pause the current song
    }
    setCurrentSong(null);
    setIsPlaying(false);
    
    // Remove token and navigate to login
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <Box
          component="img"
          src="/logo.png"
          alt="Melo"
          sx={{ 
            height: 40,
            cursor: 'pointer',
            objectFit: 'contain'
          }}
          onClick={() => navigate('/')}
        />
        <Box sx={{ flexGrow: 1 }} />
        <Box>
          <Button color="inherit" onClick={() => navigate('/')}>
            Home
          </Button>
          {token ? (
            <>
              <Button color="inherit" onClick={handleLogout}>
                Logout
              </Button>
              <Button 
                color="inherit" 
                component={Link} 
                to="/account"
                sx={{ 
                  // textTransform: 'none',
                  mx: 1
                }}
              >
                Account
              </Button>
            </>
          ) : (
            <>
              <Button color="inherit" onClick={() => navigate('/login')}>
                Login
              </Button>
              <Button color="inherit" onClick={() => navigate('/register')}>
                Register
              </Button>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar; 